
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin":"auto","background":"#fff"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"margin:auto;background:#fff","width":"200","height":"200","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50","cy":"50","r":"23","stroke-width":"5","stroke":"#d2d2d2","stroke-dasharray":"36.12831551628262 36.12831551628262","fill":"none","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","dur":"1.9607843137254901s","repeatCount":"indefinite","keyTimes":"0;1","values":"0 50 50;360 50 50"}})]),_c('circle',{attrs:{"cx":"50","cy":"50","r":"17","stroke-width":"5","stroke":"#eee","stroke-dasharray":"26.703537555513243 26.703537555513243","stroke-dashoffset":"26.704","fill":"none","stroke-linecap":"round"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","dur":"1.9607843137254901s","repeatCount":"indefinite","keyTimes":"0;1","values":"0 50 50;-360 50 50"}})])])
          )
        }
      }
    